import { render, staticRenderFns } from "./FGMCreateUserGroup.vue?vue&type=template&id=50ebe42e&scoped=true"
import script from "./FGMCreateUserGroup.vue?vue&type=script&lang=js"
export * from "./FGMCreateUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ebe42e",
  null
  
)

export default component.exports